import i18n from '@/locales/i18n'
import { SUPPORTFAQ_ROUTE } from '@/router/routes'
import type { RouteType } from '@/types/Route'
import SupportFAQView from '@/views/SupportFAQView/SupportFAQView.vue'
import { ref } from 'vue'

export enum ESupportFaqRoutes {
    SUPPORT_FAQ_TABLE = 'supportFaqTable',
    SUPPORT_FAQ_DETAIL = 'supportFaqDetail'
}
export const ESupportFaqRoutesValues = [
    ESupportFaqRoutes.SUPPORT_FAQ_TABLE,
    ESupportFaqRoutes.SUPPORT_FAQ_DETAIL
]

const routes: RouteType[] = [
    {
        path: SUPPORTFAQ_ROUTE,
        name: ESupportFaqRoutes.SUPPORT_FAQ_TABLE,
        component: SupportFAQView,
        meta: {
            title: ref(i18n.global.t('menu.supportFaq'))
        }
    },
    {
        path: `${SUPPORTFAQ_ROUTE}/:id`,
        name: ESupportFaqRoutes.SUPPORT_FAQ_DETAIL,
        component: SupportFAQView,
        meta: {
            title: ref(i18n.global.t('menu.supportFaq'))
        }
    }
]

export default routes
